interface PriceSettingsWrapper {
	pricePercentage: null|number;
	priceDecimalsPreference: null|number|string;
}

export class ProductBatchItemPricePercentagePayloadModel {
	old: PriceSettingsWrapper = {
		pricePercentage: null,
		priceDecimalsPreference: null,
	};

	constructor(p?: Partial<ProductBatchItemPricePercentagePayloadModel>) {
		Object.assign(this, p)
	}
}
